var _path, _path2, _rect, _path3, _ellipse, _rect2, _path4, _ellipse2, _rect3, _path5, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivateGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3722 30.7112C56.5349 30.8739 56.7987 30.8739 56.9615 30.7112L59.6131 28.0595C59.7758 27.8968 59.7758 27.633 59.6131 27.4703C59.4504 27.3076 59.1866 27.3076 59.0239 27.4703L56.6668 29.8273L54.3098 27.4703C54.1471 27.3076 53.8833 27.3076 53.7206 27.4703C53.5578 27.633 53.5578 27.8968 53.7206 28.0595L56.3722 30.7112ZM43.3335 14.5832H53.3335V13.7499H43.3335V14.5832ZM56.2502 17.4999V30.4166H57.0835V17.4999H56.2502ZM53.3335 14.5832C54.9443 14.5832 56.2502 15.8891 56.2502 17.4999H57.0835C57.0835 15.4288 55.4046 13.7499 53.3335 13.7499V14.5832Z",
    fill: "#27364B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0389 57.3778C23.2016 57.5406 23.4654 57.5406 23.6281 57.3778L26.2798 54.7262C26.4425 54.5635 26.4425 54.2997 26.2798 54.1369C26.1171 53.9742 25.8532 53.9742 25.6905 54.1369L23.3335 56.494L20.9765 54.1369C20.8138 53.9742 20.5499 53.9742 20.3872 54.1369C20.2245 54.2997 20.2245 54.5635 20.3872 54.7262L23.0389 57.3778ZM22.9168 22.4999V57.0832H23.7502V22.4999H22.9168Z",
    fill: "#27364B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4.16656,
    width: 43.3333,
    height: 16.6667,
    rx: 3.33333,
    fill: "#27364B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 9.16652C1.6665 7.32557 3.15889 5.83319 4.99984 5.83319H41.6665C43.5075 5.83319 44.9998 7.32558 44.9998 9.16652V19.1665C44.9998 21.0075 43.5075 22.4999 41.6665 22.4999H4.99983C3.15888 22.4999 1.6665 21.0075 1.6665 19.1665V9.16652Z",
    fill: "#4FA0E3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.16667,
    cy: 14.1665,
    rx: 4.16667,
    ry: 4.16667,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 30.8332,
    width: 43.3333,
    height: 16.6667,
    rx: 3.33333,
    fill: "#27364B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6665 35.8332C36.6665 33.9923 38.1589 32.4999 39.9998 32.4999H76.6665C78.5075 32.4999 79.9998 33.9923 79.9998 35.8332V45.8332C79.9998 47.6742 78.5075 49.1665 76.6665 49.1665H39.9998C38.1589 49.1665 36.6665 47.6742 36.6665 45.8332V35.8332Z",
    fill: "#4FA0E3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.1667,
    cy: 40.8332,
    rx: 4.16667,
    ry: 4.16667,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 57.4999,
    width: 43.3333,
    height: 16.6667,
    rx: 3.33333,
    fill: "#27364B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 62.4999C1.6665 60.6589 3.15889 59.1666 4.99984 59.1666H41.6665C43.5075 59.1666 44.9998 60.6589 44.9998 62.4999V72.4999C44.9998 74.3408 43.5075 75.8332 41.6665 75.8332H4.99983C3.15888 75.8332 1.6665 74.3408 1.6665 72.4999V62.4999Z",
    fill: "#4FA0E3"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.16667,
    cy: 67.4999,
    rx: 4.16667,
    ry: 4.16667,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateGroup);
export default __webpack_public_path__ + "static/media/privateGroup.15ba9ea3ef93d70391233caf1b697d4a.svg";
export { ForwardRef as ReactComponent };